import * as Sentry from '@sentry/react'
import { getBblCode } from 'shared/utils/bbl'
import { isStageEnvironment } from 'shared/utils/isStageEnvironment'
import { isTestEnvironment } from 'shared/utils/isTestEnvironment'

export const initSentry = () => {
  const isProdEnvironment = process.env.NODE_ENV === 'production'
  const isTestOrStageEnvironment = isTestEnvironment || isStageEnvironment

  // check if we are a abbl user, if not, don't init sentry
  const bblCode = getBblCode()

  if (bblCode === 'abbl' || bblCode === 'usbl' || isTestOrStageEnvironment) {
    Sentry.init({
      dsn: 'https://553d8defc1527902da676c2c2456fdb8@o4508738328657920.ingest.de.sentry.io/4509829960826960',
      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: true,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.captureConsoleIntegration({
          levels: ['error'],
        }),
      ],
      environment: isTestOrStageEnvironment ? 'development' : 'production',
      // Tracing
      tracesSampleRate: isProdEnvironment ? 0.2 : 0, //  Capture 20% of the transactions
      // Filter out certain errors
      ignoreErrors: [
        // HTTP related errors
        /^Http failure/,
        /^Server returned/,

        'No client available', // When no client is available
        'Connection disconnected with error', // Websocket closed
        'invalid_grant', // OIDC error
        'Network Error', // Network error(mabye cors?)
        'Failed to start the connection', // Websocket connection failed
        'Failed to complete negotiation', // Websocket negotiation failed
      ],
      beforeSend(event) {
        // Extract HTTP status code from axios errors to create separate groups
        const message = event.message || ''

        // Check if this is an axios error from console.error
        // The message format is: "An ${errorStatus} error occured via axios:"
        const axiosErrorMatch = message.match(
          /An (\d+) error occured via axios/
        )
        if (axiosErrorMatch) {
          const statusCode = axiosErrorMatch[1]
          // Customize fingerprint to group by HTTP status code
          event.fingerprint = [`axios-error-${statusCode}`]
        }

        return event
      },
      enabled: isProdEnvironment && !window.location.host.includes('autotest'),
    })
  }
}
